import { useState } from "react";
import { Tooltip } from "ui/popovers/Tooltip";
import Switch from "./Switch";

export function Wrapper({ children }) {
  return <Tooltip.Provider>{children}</Tooltip.Provider>;
}

<Wrapper>

## Basic Usage

export function BasicSwitch() {
  const [enabled, setEnabled] = useState(false);
  return <Switch label="Enable notifications" checked={enabled} onChangeBoolean={setEnabled} />;
}

<BasicSwitch />

---

## Sizes

export function SwitchSizes() {
  const [enabled, setEnabled] = useState(true);
  return (
    <div style={{ display: "flex", flexDirection: "column", gap: "12px" }}>
      <Switch label="Default" checked={enabled} onChangeBoolean={setEnabled} />
      <Switch label="Small" checked={enabled} onChangeBoolean={setEnabled} size="small" />
    </div>
  );
}

<SwitchSizes />

---

## Multiple Switches

export function MultipleSwitches() {
  const [darkMode, setDarkMode] = useState(true);
  const [sound, setSound] = useState(false);
  const [autoSave, setAutoSave] = useState(true);
  return (
    <div style={{ display: "flex", flexDirection: "column", gap: "12px" }}>
      <Switch label="Dark mode" checked={darkMode} onChangeBoolean={setDarkMode} />
      <Switch label="Sound effects" checked={sound} onChangeBoolean={setSound} />
      <Switch label="Auto-save" checked={autoSave} onChangeBoolean={setAutoSave} />
    </div>
  );
}

<MultipleSwitches />

---

## Disabled States

<div style={{ display: "flex", flexDirection: "column", gap: "12px" }}>
  <Switch label="Disabled (off)" checked={false} disabled />
  <Switch label="Disabled (on)" checked disabled />
</div>

---

## With Tooltips

export function TooltipSwitches() {
  const [privacy, setPrivacy] = useState(false);
  const [analytics, setAnalytics] = useState(true);
  return (
    <div style={{ display: "flex", flexDirection: "column", gap: "12px" }}>
      <Switch
        label="Private mode"
        checked={privacy}
        onChangeBoolean={setPrivacy}
        tooltip="Activity will not be tracked"
      />
      <Switch
        label="Analytics"
        checked={analytics}
        onChangeBoolean={setAnalytics}
        tooltip="Share anonymous usage data"
      />
    </div>
  );
}

<TooltipSwitches />

</Wrapper>
